import React from 'react'
import { FaClock } from 'react-icons/fa' // FontAwesome clock icon
import { useContext } from './../Context'

const SignonLog = () => {

    const { globalState, setGlobalState, fetchSignons } = useContext()
    const { isModalOpen, signons } = globalState


    const openModal = () => {
        fetchSignons() // Fetch signons when the modal is opened
        setGlobalState((prevState) => ({ ...prevState, isModalOpen: true }))
    }

    const closeModal = () => {
        setGlobalState({ ...globalState, isModalOpen: false })
    }

    return (
        <div>
            <button className="clock-icon" onClick={openModal}>
                <FaClock size={24} />
            </button>

            {isModalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <span className="close" onClick={closeModal}>&times;</span>
                        <h2>Sign-on Log</h2>
                        <ul className="signon-list">
                            {signons.map((signon) => (
                                <li key={signon.id} className="signon-item">
                                    {signon.name} - {signon.action} @ {new Date(signon.timestamp).toLocaleString()}
                                    {signon.action === 'signon' && ` - Estimated Return: ${signon.estimatedReturn}`}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </div>
    )
}

export default SignonLog